import { render, staticRenderFns } from "./TutorLayout.vue?vue&type=template&id=9d4ed998&scoped=true"
import script from "./TutorLayout.vue?vue&type=script&lang=js"
export * from "./TutorLayout.vue?vue&type=script&lang=js"
import style0 from "./TutorLayout.vue?vue&type=style&index=0&id=9d4ed998&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4ed998",
  null
  
)

export default component.exports